//   // import Swiper JS
//   import Swiper, { Navigation, Pagination }  from 'swiper';
//   // import Swiper styles
//   import 'swiper/css';
//   import 'swiper/css/navigation';
//   import 'swiper/css/pagination';

//   // configure Swiper to use modules
//   Swiper.use([Navigation, Pagination]);

// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';

var swipres = [];
document.querySelectorAll('.swiper').forEach(el => {
    const module = el.closest('.module');

    var s = new Swiper(el, {
        
        // If we need pagination
        pagination: {
            el: el.querySelector('.swiper-pagination'),
            clickable: true
        },

        // Navigation arrows
        // navigation: false,
        navigation: {
        	nextEl: module.querySelector('.swiper-button-next'),
        	prevEl: module.querySelector('.swiper-button-prev'),
        },
        // Default parameters
        slidesPerView: 1,
        spaceBetween: 1,
        // Responsive breakpoints
        // breakpoints: {
        //     // when window width is >= 320px
        //     320: {
        //         slidesPerView: 1,
        //         // spaceBetween: 0
        //     },
        //     // when window width is >= 480px
        //     480: {
        //         slidesPerView: 2,
        //         // spaceBetween: 0
        //     },
        //     // when window width is >= 640px
        //     1000: {
        //         slidesPerView: 3,
        //         // spaceBetween: 0
        //     }
        // }
    });

    swipres.push(s);

});

export {
    swipres
}